import { customization } from '@yola/ws-sdk';
import getFallbackColorScheme from './get-fallback-color-scheme';

const getSafeColorScheme = (schemeId, palette) => {
  if (
    typeof schemeId === 'string' &&
    schemeId.startsWith(customization.constants.CUSTOM_COLOR_SCHEME_PREFIX) &&
    !palette.schemes?.[schemeId]
  ) {
    return getFallbackColorScheme(schemeId);
  }
  return schemeId;
};

export default getSafeColorScheme;
